export const en = {
  translation: {
    sign_out: "Sign Out",
    send: "Send",
    cancel: "Cancel",
    manage_email_notifications: {
      title: "Manage Email Notifications",
      program_open_notifications: "Open funds"
    },
    environment_header: "This is a {{environment}} environment",
    footer: "© {{year}} TailorMed. All rights reserved",
    main_title: "Good {{timeOfDay}}, {{firstName}}",
    main_subtitle: "Search By Assistance Program",
    not_found: "Not found",
    login_email_support: "E-mail support",
    contact_support: "Contact Support",
    support: {
      title: "Contact Support: {{ name }}",
      disclaimer: "Please make sure not to share Protected Health Information (ePHI) in the subject",
      description: "Description",
      subject: "Subject",
      description_required: "Description is required",
      subject_required: "Subject is required"
    },
    assistance_programs: {
      search_placeholder: "Search by Program Name",
      table: {
        name: "Name",
        provided_by: "Provided By",
        type: "Type",
        Insurance: "Insurance",
        diagnosis: "Diagnosis",
        grant_amount: "Grant Amount",
        status: "Status"
      },
      filters: {
        title: "FILTERS",
        fund_type: "Fund Type",
        diagnosis_name: "Diagnosis Name",
        diagnosis_code: "Diagnosis ICD Code",
        insurance_type: "Insurance Type",
        drug_name: "Drug Name",
        allowed_states: "Allowed States",
        show_only: "Show only open funds",
        clear_all: "Clear All",
        manufacturer_other_tooltip:
          "Filtering by Manufacturer Other includes: Manufacturer Quickstart, Manufacturer Trial, Manufacturer Bridge, Manufacturer Voucher, and Manufacturer Coupon or Rebate."
      },
      program_types: {
        foundation_copay: "Foundation Copay",
        foundation_premium: "Foundation Premium",
        manufacturer_copay: "Manufacturer Copay",
        manufacturer_pap: "Manufacturer PAP and Replacement",
        manufacturer_other: "Manufacturer Other",
        ancillary_living: "Ancillary/Living Expenses",
        support_adherence: "Support Program",
        government_plans: "Government Plan",
        discount: "Discount"
      },
      modal: {
        benefits: "Benefits",
        eligibility: "Eligibility",
        clinical_information: "Clinical Information",
        x_months_lookback: "{{count}} month lookback period",
        x_days_lookback: "{{count}} day lookback period",
        no_lookback_period: "No lookback period",
        enrollment_expires_month: "Expires {{applicationRenewalTimeInMonths}} months from first use or activation",
        enrollment_expires_end_of_year: "Expires at the end of the calendar year from first use or activation",
        enrollment_info: "ENROLLMENT INFORMATION",
        who_can_enroll: "Who Can Enroll",
        patient_authorization: "Patient Authorization",
        patient_consent_required: "Required",
        patient_consent_not_required: "Not Required",
        phone1: "Phone 1",
        phone2: "Phone 2",
        fax: "Fax",
        provider_portal: "Provider Portal",
        pharmacy_portal: "Pharmacy Portal",
        program_website: "Program Website",
        pharmacy_website: "Pharmacy Website"
      }
    },
    error_fallback: {
      title: "Unexpected Error",
      ok_text: "Go Back",
      p1: "Uh oh! Something went wrong on our end.",
      p2: "Click a button below to reload or go back to the previous page."
    }
  }
};
